import { useState, useRef } from "react";
import { C } from "../../constants";

export default function FileUpload({ files, onChange }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const addFiles = (newFiles) => {
    const fileList = Array.from(newFiles);
    // Max 10MB per file
    const maxSize = 10 * 1024 * 1024;
    const valid = fileList.filter(f => {
      if (f.size > maxSize) {
        alert(`"${f.name}" exceeds 10MB limit and was not added.`);
        return false;
      }
      return true;
    });

    // Convert to base64
    valid.forEach(f => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result.split(",")[1]; // strip data:...;base64,
        onChange(prev => [...prev, {
          name: f.name,
          mimeType: f.type || "application/octet-stream",
          size: f.size,
          base64: base64,
        }]);
      };
      reader.readAsDataURL(f);
    });
  };

  const removeFile = (idx) => {
    onChange(prev => prev.filter((_, i) => i !== idx));
  };

  const formatSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files.length > 0) {
      addFiles(e.dataTransfer.files);
    }
  };

  return (
    <div>
      {/* Drop zone */}
      <div
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        style={{
          padding: "24px", border: `2px dashed ${dragOver ? C.navy : C.border}`,
          borderRadius: 12, textAlign: "center",
          background: dragOver ? `${C.navy}05` : C.grayBg,
          cursor: "pointer", transition: "all 0.2s",
        }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>📎</div>
        <p style={{ fontSize: 13, color: C.t2, margin: "0 0 4px" }}>
          Click to select or drag & drop files here
        </p>
        <p style={{ fontSize: 12, color: C.t3, fontStyle: "italic", margin: 0 }}>
          Haga clic para seleccionar o arrastre archivos aquí
        </p>
        <p style={{ fontSize: 11, color: C.t3, marginTop: 8 }}>
          Blueprints, photos, PDFs — max 10MB per file
        </p>
        <input
          ref={inputRef}
          type="file"
          multiple
          style={{ display: "none" }}
          onChange={(e) => {
            if (e.target.files.length > 0) {
              addFiles(e.target.files);
              e.target.value = ""; // reset so same file can be added again
            }
          }}
        />
      </div>

      {/* File list */}
      {files.length > 0 && (
        <div style={{ marginTop: 12 }}>
          {files.map((f, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "8px 12px", borderRadius: 8,
              background: C.white, border: `1px solid ${C.border}`,
              marginBottom: 6,
            }}>
              <span style={{ fontSize: 16 }}>📄</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, color: C.t1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</div>
                <div style={{ fontSize: 11, color: C.t3 }}>{formatSize(f.size)}</div>
              </div>
              <button onClick={(e) => { e.stopPropagation(); removeFile(i); }}
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  color: C.t3, fontSize: 18, padding: "2px 6px", borderRadius: 4,
                  transition: "all 0.15s", fontFamily: "inherit",
                }}
                onMouseEnter={e => { e.currentTarget.style.color = C.red; e.currentTarget.style.background = "#FEF2F2"; }}
                onMouseLeave={e => { e.currentTarget.style.color = C.t3; e.currentTarget.style.background = "none"; }}>
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
